export default __webpack_public_path__ + "static/media/RR310_Posterior.be66e26e.webp";